// Base
import Image, { StaticImageData } from 'next/image'

// Components
import { Box, Text, Flex } from 'yard-utilities/components'
import Tag from '@components/v25/common/tag/Tag'
import TextReviewCard from '../review/text-review/TextReviewCard'

// Styles
import styles from './ExperienceCard.module.sass'

// Data
import imagePlaceholder from '@data/image-placeholder.json'

interface RecentDealCardProps {
  img: string | StaticImageData
  card?: {
    destination: string
    date: string
    prices: { old: number; new: number; currency?: string }
  }
  review: {
    name: string
    quote: string
    message: string
    memberSince: number
  }
}

const ExperienceCard = ({ img, card, review }: RecentDealCardProps) => {
  return (
    <Flex
      flexDirection="column"
      rowGap={{ sm: 24 }}
      className={styles.container}
    >
      <div>
        <div className={styles.image}>
          <Image
            src={img}
            alt={`Image of ${review.name}`}
            fill
            sizes="800px"
            priority
            blurDataURL={imagePlaceholder}
            placeholder="blur"
          />

          {card && (
            <Box
              borderRadius={{ sm: [8, 8, 8, 0] }}
              padding={{ sm: [12] }}
              backgroundColor="yellow-10"
              shadow="shadowDefault"
              className={styles.labelBox}
            >
              <Text tagName="h4" variant="title-3" spacing={{ sm: 4 }}>
                {card.destination}
              </Text>

              <Text
                tagName="p"
                variant="body-5"
                textColor="grey-2"
                spacing={{ sm: 4 }}
              >
                {card.date}
              </Text>

              <Text tagName="p" variant="body-3" spacing={{ sm: 8 }}>
                Roundtrip deal
              </Text>

              <Flex alignItems="center" columnGap={{ sm: 4 }}>
                <Text
                  tagName="p"
                  variant="body-1"
                  align="center"
                  fontWeight={500}
                  textColor="red"
                  decoration="lineThrough"
                >
                  {card.prices.currency || '$'}
                  {card.prices.old.toLocaleString()}
                </Text>

                <Tag
                  variant="type-4"
                  backgroundColor="yellow"
                  textColor="black"
                  textSize="title-4"
                  fontWeight={700}
                >
                  {card.prices.currency || '$'}
                  {card.prices.new.toLocaleString()}
                </Tag>
              </Flex>

              <div className={styles.labelFold} />
            </Box>
          )}
        </div>
      </div>

      <Box padding={{ sm: [0, 8] }}>
        <TextReviewCard {...review} />
      </Box>
    </Flex>
  )
}

export default ExperienceCard
